import React, { FC } from 'react'

import { Button, ButtonProps } from '@/shared/ui'
import { Icon } from '@/shared/ui/icon'

import YaSplitLogo from '../../assets/svg/ya-split-logo.svg'

import styles from './YaPaySplitButton.module.scss'

export type YaPaySplitButtonProps = ButtonProps

export const YaPaySplitButton: FC<YaPaySplitButtonProps> = props => {
	return (
		<Button
			{...props}
			className={`${styles.button} ${props.isLoading ? styles.loading : ''}`}
			style={props.disabled || props.isLoading ? { pointerEvents: `none`, opacity: 0.5 } : {}}>
			<div className={styles.inner}>
				<span>Оплатить частями в</span>
				<Icon icon={YaSplitLogo} width="64" height="17" />
			</div>
		</Button>
	)
}
